// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.verifydata_dataVerificationContainer__1iJNM {
  padding: 30px;
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
  border-radius: 12px;
  margin-bottom: 30px;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  min-height: 100vh;
  position: relative;
}
.verifydata_dataVerificationContainer__1iJNM .verifydata_contentWrapper__3O80X {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px;
}
.verifydata_dataVerificationContainer__1iJNM h2 {
  text-align: center;
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 30px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.verifydata_uploadProgressContainer__5E4gW {
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  color: white;
  animation: verifydata_slideDown__2zbkr 0.5s ease-out;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressHeader__908Wy {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressHeader__908Wy .verifydata_progressIcon__SYPE8 {
  font-size: 24px;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: verifydata_spin__LwSTr 0.6s linear infinite;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressHeader__908Wy .verifydata_progressTitle__jmdAI {
  font-size: 18px;
  font-weight: 600;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressBarContainer__xQtv1 {
  position: relative;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  height: 20px;
  margin-bottom: 15px;
  overflow: hidden;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressBarContainer__xQtv1 .verifydata_progressBar__xnkEV {
  height: 100%;
  background: linear-gradient(90deg, #0467a0, #035a8a);
  border-radius: 10px;
  transition: width 0.3s ease;
  position: relative;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressBarContainer__xQtv1 .verifydata_progressBar__xnkEV::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: verifydata_shimmer__tt6iS 1.5s infinite;
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressBarContainer__xQtv1 .verifydata_progressText__uO6US {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 14px;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
.verifydata_uploadProgressContainer__5E4gW .verifydata_progressStatus__88KQP {
  font-size: 14px;
  opacity: 0.9;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  text-align: center;
}

@keyframes verifydata_spin__LwSTr {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes verifydata_shimmer__tt6iS {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes verifydata_slideDown__2zbkr {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.verifydata_searchContainer__WPDAh {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.verifydata_searchBox__ek0hx {
  flex: 1 1;
}

.verifydata_searchInput__gke-w {
  width: 100%;
  padding: 12px 20px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  transition: border-color 0.3s ease;
}
.verifydata_searchInput__gke-w:focus {
  outline: none;
  border-color: #0467a0;
  box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);
}
.verifydata_searchInput__gke-w::placeholder {
  color: #6c757d;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_itemsPerPageContainer__CT6WU {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}
.verifydata_itemsPerPageContainer__CT6WU label {
  font-weight: 600;
  color: #495057;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_itemsPerPageSelect__Xq6qk {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  cursor: pointer;
}
.verifydata_itemsPerPageSelect__Xq6qk:focus {
  outline: none;
  border-color: #667eea;
}

.verifydata_filterToggleButton__5rm2V {
  padding: 10px 20px;
  border: 2px solid #0467a0;
  border-radius: 8px;
  background: linear-gradient(135deg, #0467a0, #ff0000);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.verifydata_filterToggleButton__5rm2V:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}

.verifydata_actionButtons__VgA7l {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.verifydata_orderNote__TsTNn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #e6f3ff, #cce7ff);
  border: 1px solid #0467a0;
  border-radius: 8px;
  margin: 10px 0;
  font-size: 14px;
  color: #0467a0;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  box-shadow: 0 2px 8px rgba(4, 103, 160, 0.1);
  transition: all 0.3s ease;
}
.verifydata_orderNote__TsTNn:hover {
  background: linear-gradient(135deg, #cce7ff, #b3d9ff);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(4, 103, 160, 0.2);
}
.verifydata_orderNote__TsTNn .verifydata_orderIcon__Xheh8 {
  font-size: 16px;
  animation: verifydata_pulse__3mIv\\+ 2s infinite;
}
.verifydata_orderNote__TsTNn .verifydata_orderText__3v5mc {
  font-weight: 500;
}
.verifydata_orderNote__TsTNn .verifydata_orderText__3v5mc strong {
  color: #0d47a1;
}

@keyframes verifydata_pulse__3mIv\\+ {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.verifydata_navArrow__52jDC {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 2px solid #667eea;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 5px;
  text-decoration: none;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.verifydata_navArrow__52jDC:hover {
  transform: translateY(-2px) scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #5a6fd8, #6a4190);
}
.verifydata_navArrow__52jDC:active {
  transform: translateY(0) scale(0.95);
}
.verifydata_navArrow__52jDC.verifydata_disabled__QaMdP {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.verifydata_navArrow__52jDC.verifydata_disabled__QaMdP:hover {
  transform: none;
  box-shadow: none;
}
.verifydata_navArrow__52jDC.verifydata_leftArrow__rBcwC::before {
  content: "←";
  font-size: 20px;
  font-weight: bold;
}
.verifydata_navArrow__52jDC.verifydata_rightArrow__gM2XI::before {
  content: "→";
  font-size: 20px;
  font-weight: bold;
}
.verifydata_navArrow__52jDC.verifydata_firstArrow__jV\\+Bq::before {
  content: "⟪";
  font-size: 18px;
  font-weight: bold;
}
.verifydata_navArrow__52jDC.verifydata_lastArrow__gu-Zx::before {
  content: "⟫";
  font-size: 18px;
  font-weight: bold;
}

.verifydata_actionButton__QRowN {
  padding: 10px 15px;
  border: 2px solid #0467a0;
  border-radius: 8px;
  background: linear-gradient(135deg, #0467a0, #035a8a);
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  white-space: nowrap;
}
.verifydata_actionButton__QRowN:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}
.verifydata_actionButton__QRowN:nth-child(2) {
  border-color: #ff0000;
  background: linear-gradient(135deg, #ff0000, #cc0000);
}
.verifydata_actionButton__QRowN:nth-child(2):hover {
  box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);
}
.verifydata_actionButton__QRowN:nth-child(3) {
  border-color: #0467a0;
  background: linear-gradient(135deg, #0467a0, #035a8a);
}
.verifydata_actionButton__QRowN:nth-child(3):hover {
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}

.verifydata_filterContainer__g7MuZ {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}
.verifydata_filterContainer__g7MuZ h3 {
  text-align: center;
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 25px;
  font-weight: 600;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_filterSection__c4nEP {
  margin-bottom: 30px;
}
.verifydata_filterSection__c4nEP h4 {
  color: #495057;
  font-size: 1.2rem;
  margin-bottom: 15px;
  font-weight: 600;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.verifydata_filterGrid__P-1Og {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.verifydata_filterItem__Mpb1Y {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.verifydata_filterItem__Mpb1Y label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_filterInput__79pGO {
  padding: 10px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  transition: border-color 0.3s ease;
}
.verifydata_filterInput__79pGO:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.verifydata_filterInput__79pGO::placeholder {
  color: #6c757d;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_filterSelect__PqIFq {
  padding: 10px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.verifydata_filterSelect__PqIFq:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.verifydata_filterInfo__Rj-z6 {
  text-align: center;
  padding: 15px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 8px;
  margin-top: 20px;
}
.verifydata_filterInfo__Rj-z6 span {
  color: #495057;
  font-size: 14px;
  font-weight: 600;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_loadingContainer__pcCYB {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.verifydata_loadingContainer__pcCYB p {
  color: #6c757d;
  font-size: 16px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_tableContainer__75Pq2 {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  max-width: 100%;
  box-sizing: border-box;
}
.verifydata_tableContainer__75Pq2 h3 {
  text-align: center;
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-weight: 600;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_table__Cne71 {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  min-width: 1400px;
}
.verifydata_table__Cne71 th, .verifydata_table__Cne71 td {
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #e9ecef;
  font-size: 12px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  vertical-align: middle;
}
.verifydata_table__Cne71 th {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 11px;
}
.verifydata_table__Cne71 th:first-child {
  text-align: center;
}
.verifydata_table__Cne71 tbody tr {
  transition: all 0.3s ease;
}
.verifydata_table__Cne71 tbody tr:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
@media (max-width: 1200px) {
  .verifydata_table__Cne71 {
    min-width: 1200px;
  }
  .verifydata_table__Cne71 th, .verifydata_table__Cne71 td {
    padding: 8px 4px;
    font-size: 10px;
  }
}

.verifydata_statusContainer__Dzy3I {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.verifydata_statusCheckbox__A\\+22x {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #28a745;
}
.verifydata_statusCheckbox__A\\+22x:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.verifydata_statusLabel__83Oe- {
  font-size: 16px;
  font-weight: bold;
  color: #28a745;
}
.verifydata_statusLabel__83Oe-.verifydata_approved__SZVSm {
  color: #28a745;
}
.verifydata_statusLabel__83Oe-.verifydata_pending__6JTOu {
  color: #dc3545;
}

.verifydata_statusSelect__4f3rf {
  padding: 6px 10px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  font-size: 12px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  cursor: pointer;
  min-width: 100px;
}
.verifydata_statusSelect__4f3rf:focus {
  outline: none;
  border-color: #667eea;
}

.verifydata_commentInput__duTC5 {
  padding: 6px 10px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  font-size: 12px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  min-width: 120px;
}
.verifydata_commentInput__duTC5:focus {
  outline: none;
  border-color: #667eea;
}
.verifydata_commentInput__duTC5::placeholder {
  color: #6c757d;
  font-size: 11px;
}

.verifydata_locationInput__rnYKW {
  padding: 6px 10px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  font-size: 12px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  background: white;
  min-width: 100px;
}
.verifydata_locationInput__rnYKW:focus {
  outline: none;
  border-color: #667eea;
}
.verifydata_locationInput__rnYKW::placeholder {
  color: #6c757d;
  font-size: 11px;
}

.verifydata_updateButton__GbJdW {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #0467a0, #035a8a);
  color: white;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.verifydata_updateButton__GbJdW:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(4, 103, 160, 0.3);
}

.verifydata_paginationContainer__cdH77 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 2px solid #e9ecef;
}

.verifydata_paginationInfo__919AS {
  color: #6c757d;
  font-size: 14px;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}

.verifydata_paginationButtons__liaav {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.verifydata_paginationButton__iecjO {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  min-width: 40px;
}
.verifydata_paginationButton__iecjO:hover:not(:disabled) {
  border-color: #0467a0;
  color: #0467a0;
  transform: translateY(-1px);
}
.verifydata_paginationButton__iecjO:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.verifydata_paginationButton__iecjO.verifydata_active__QCLzJ {
  background: linear-gradient(135deg, #0467a0, #ff0000);
  color: white;
  border-color: #0467a0;
}

.verifydata_scrollableContent__K2VCL {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.verifydata_scrollableContent__K2VCL::-webkit-scrollbar {
  height: 8px;
}
.verifydata_scrollableContent__K2VCL::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.verifydata_scrollableContent__K2VCL::-webkit-scrollbar-thumb {
  background: #0467a0;
  border-radius: 4px;
}
.verifydata_scrollableContent__K2VCL::-webkit-scrollbar-thumb:hover {
  background: #035a8a;
}

.verifydata_flexCenter__rqqh4 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.verifydata_flexWrap__ols7f {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .verifydata_dataVerificationContainer__1iJNM {
    padding: 20px;
  }
  .verifydata_searchContainer__WPDAh {
    flex-direction: column;
    gap: 15px;
  }
  .verifydata_itemsPerPageContainer__CT6WU {
    width: 100%;
    justify-content: center;
  }
  .verifydata_actionButtons__VgA7l {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }
  .verifydata_actionButton__QRowN {
    font-size: 12px;
    padding: 8px 12px;
  }
  .verifydata_filterContainer__g7MuZ {
    padding: 20px;
  }
  .verifydata_filterGrid__P-1Og {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .verifydata_filterInput__79pGO, .verifydata_filterSelect__PqIFq {
    font-size: 13px;
    padding: 8px 12px;
  }
  .verifydata_tableContainer__75Pq2 {
    padding: 15px;
  }
  .verifydata_table__Cne71 {
    min-width: 800px;
  }
  .verifydata_table__Cne71 th, .verifydata_table__Cne71 td {
    padding: 10px;
    font-size: 12px;
  }
  .verifydata_statusSelect__4f3rf, .verifydata_commentInput__duTC5, .verifydata_locationInput__rnYKW {
    font-size: 11px;
    padding: 4px 8px;
  }
  .verifydata_paginationContainer__cdH77 {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .verifydata_dataVerificationContainer__1iJNM {
    padding: 15px;
  }
  .verifydata_searchContainer__WPDAh {
    padding: 20px;
    flex-direction: column;
    gap: 15px;
  }
  .verifydata_actionButtons__VgA7l {
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .verifydata_actionButton__QRowN {
    font-size: 11px;
    padding: 6px 10px;
  }
  .verifydata_navArrow__52jDC {
    width: 35px;
    height: 35px;
    font-size: 16px;
    margin: 0 3px;
  }
  .verifydata_navArrow__52jDC.verifydata_leftArrow__rBcwC::before, .verifydata_navArrow__52jDC.verifydata_rightArrow__gM2XI::before {
    font-size: 18px;
  }
  .verifydata_navArrow__52jDC.verifydata_firstArrow__jV\\+Bq::before, .verifydata_navArrow__52jDC.verifydata_lastArrow__gu-Zx::before {
    font-size: 16px;
  }
  .verifydata_filterContainer__g7MuZ {
    padding: 15px;
  }
  .verifydata_filterGrid__P-1Og {
    gap: 10px;
  }
  .verifydata_filterInput__79pGO, .verifydata_filterSelect__PqIFq {
    font-size: 12px;
    padding: 6px 10px;
  }
  .verifydata_tableContainer__75Pq2 {
    padding: 10px;
    overflow-x: auto;
  }
  .verifydata_table__Cne71 {
    min-width: 700px;
  }
  .verifydata_table__Cne71 th, .verifydata_table__Cne71 td {
    padding: 8px;
    font-size: 11px;
  }
  .verifydata_statusSelect__4f3rf, .verifydata_commentInput__duTC5, .verifydata_locationInput__rnYKW {
    font-size: 10px;
    padding: 3px 6px;
    min-width: 80px;
  }
  .verifydata_paginationContainer__cdH77 .verifydata_paginationButtons__liaav {
    flex-wrap: wrap;
    gap: 5px;
  }
  .verifydata_paginationContainer__cdH77 .verifydata_paginationButton__iecjO {
    padding: 8px 12px;
    font-size: 12px;
  }
}
.verifydata_uploadInstructions__N9WM8 {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 2px solid #2196f3;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.1);
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionHeader__j58vX {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionHeader__j58vX .verifydata_instructionIcon__Ph51s {
  font-size: 20px;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionHeader__j58vX .verifydata_instructionTitle__oVBrh {
  font-size: 16px;
  font-weight: 700;
  color: #1976d2;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx .verifydata_stepNumber__qNjbo {
  background: #2196f3;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 2px;
}
.verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx .verifydata_stepText__Y-PhC {
  font-size: 14px;
  color: #424242;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .verifydata_uploadInstructions__N9WM8 {
    padding: 15px;
    margin: 15px 0;
  }
  .verifydata_uploadInstructions__N9WM8 .verifydata_instructionHeader__j58vX .verifydata_instructionTitle__oVBrh {
    font-size: 14px;
  }
  .verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx .verifydata_stepText__Y-PhC {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .verifydata_uploadInstructions__N9WM8 {
    padding: 12px;
    margin: 12px 0;
  }
  .verifydata_uploadInstructions__N9WM8 .verifydata_instructionHeader__j58vX .verifydata_instructionTitle__oVBrh {
    font-size: 13px;
  }
  .verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx .verifydata_stepText__Y-PhC {
    font-size: 12px;
  }
  .verifydata_uploadInstructions__N9WM8 .verifydata_instructionSteps__vyYXI .verifydata_instructionStep__rflEx .verifydata_stepNumber__qNjbo {
    width: 20px;
    height: 20px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/403/verifydata.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAEF;AACE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AACJ;AAEE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAAJ;;AAKA;EACE,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,oDAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAII;EACE,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sDAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,sDAAA;AAHN;AAOE;EACE,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AALJ;AAOI;EACE,YAAA;EACA,oDAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AALN;AAOM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sFAAA;EACA,kDAAA;AALR;AASI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;AAPN;AAWE;EACE,eAAA;EACA,YAAA;EACA,sDAAA;EACA,kBAAA;AATJ;;AAcA;EACE;IAAK,uBAAA;EAVL;EAWA;IAAO,yBAAA;EARP;AACF;AAUA;EACE;IAAK,4BAAA;EAPL;EAQA;IAAO,2BAAA;EALP;AACF;AAOA;EACE;IACE,UAAA;IACA,4BAAA;EALF;EAOA;IACE,UAAA;IACA,wBAAA;EALF;AACF;AAQA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AANF;;AASA;EACE,SAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,kCAAA;AANF;AAQE;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AANJ;AASE;EACE,cAAA;EACA,sDAAA;AAPJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AARF;AAUE;EACE,gBAAA;EACA,cAAA;EACA,sDAAA;AARJ;;AAYA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,iBAAA;EACA,eAAA;AATF;AAWE;EACE,aAAA;EACA,qBAAA;AATJ;;AAaC;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAVH;AAYG;EACE,2BAAA;EACA,6CAAA;AAVL;;AAcC;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAXH;;AAcC;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qDAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,sDAAA;EACA,4CAAA;EACA,yBAAA;AAXH;AAaG;EACE,qDAAA;EACA,2BAAA;EACA,6CAAA;AAXL;AAcG;EACE,eAAA;EACA,+CAAA;AAZL;AAeG;EACE,gBAAA;AAbL;AAeK;EACE,cAAA;AAbP;;AAkBC;EACE;IACE,mBAAA;EAfH;EAiBC;IACE,qBAAA;EAfH;EAiBC;IACE,mBAAA;EAfH;AACF;AAmBC;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,sDAAA;AAjBH;AAmBG;EACE,sCAAA;EACA,+CAAA;EACA,qDAAA;AAjBL;AAoBG;EACE,oCAAA;AAlBL;AAqBG;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAnBL;AAqBK;EACE,eAAA;EACA,gBAAA;AAnBP;AAwBG;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAtBL;AAyBG;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAvBL;AA0BG;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAxBL;AA2BG;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAzBL;;AA6BC;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,mBAAA;AA1BH;AA4BG;EACE,2BAAA;EACA,6CAAA;AA1BL;AA6BG;EACE,qBAAA;EACA,qDAAA;AA3BL;AA6BK;EACE,2CAAA;AA3BP;AA+BG;EACE,qBAAA;EACA,qDAAA;AA7BL;AA+BK;EACE,6CAAA;AA7BP;;AAkCA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;AA/BF;AAiCE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sDAAA;AA/BJ;;AAmCA;EACE,mBAAA;AAhCF;AAkCE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sDAAA;EACA,gCAAA;EACA,mBAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjCF;AAmCE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sDAAA;AAjCJ;;AAqCA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,kCAAA;AAlCF;AAoCE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAlCJ;AAqCE;EACE,cAAA;EACA,sDAAA;AAnCJ;;AAuCA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;AApCF;AAsCE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AApCJ;;AAwCA;EACE,kBAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;AArCF;AAuCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sDAAA;AArCJ;;AAyCA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AAtCF;AAwCE;EACE,cAAA;EACA,eAAA;EACA,sDAAA;AAtCJ;;AA0CA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAvCF;AAyCE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sDAAA;AAvCJ;;AA2CA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAxCF;AA0CE;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,sDAAA;EACA,sBAAA;AAxCJ;AA2CE;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EAGA,eAAA;AA3CJ;AA8CI;EACE,kBAAA;AA5CN;AAgDE;EACE,yBAAA;AA9CJ;AAgDI;EACE,yBAAA;EACA,2BAAA;EACA,yCAAA;AA9CN;AAmDE;EA3CF;IA4CI,iBAAA;EAhDF;EAkDE;IACE,gBAAA;IACA,eAAA;EAhDJ;AACF;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAjDF;;AAoDA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAjDF;AAmDE;EACE,yBAAA;EACA,qBAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAlDF;AAoDE;EACE,cAAA;AAlDJ;AAqDE;EACE,cAAA;AAnDJ;;AAuDA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AApDF;AAsDE;EACE,aAAA;EACA,qBAAA;AApDJ;;AAwDA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,iBAAA;EACA,gBAAA;AArDF;AAuDE;EACE,aAAA;EACA,qBAAA;AArDJ;AAwDE;EACE,cAAA;EACA,eAAA;AAtDJ;;AA0DA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sDAAA;EACA,iBAAA;EACA,gBAAA;AAvDF;AAyDE;EACE,aAAA;EACA,qBAAA;AAvDJ;AA0DE;EACE,cAAA;EACA,eAAA;AAxDJ;;AA4DA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;AA2DE;EACE,2BAAA;EACA,4CAAA;AAzDJ;;AA6DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,eAAA;EACA,sDAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AA1DF;;AA6DA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EACA,eAAA;AA1DF;AA4DE;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;AA1DJ;AA6DE;EACE,YAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,qDAAA;EACA,YAAA;EACA,qBAAA;AA5DJ;;AAiEA;EACE,gBAAA;EACA,kBAAA;EACA,iCAAA;AA9DF;AAgEE;EACE,WAAA;AA9DJ;AAiEE;EACE,mBAAA;EACA,kBAAA;AA/DJ;AAkEE;EACE,mBAAA;EACA,kBAAA;AAhEJ;AAkEI;EACE,mBAAA;AAhEN;;AAqEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAlEF;;AAsEA;EACE;IACE,aAAA;EAnEF;EAsEG;IACA,sBAAA;IACA,SAAA;EApEH;EAuEC;IACE,WAAA;IACA,uBAAA;EArEH;EAwEC;IACE,eAAA;IACA,uBAAA;IACA,QAAA;EAtEH;EAyEC;IACE,eAAA;IACA,iBAAA;EAvEH;EA0EA;IACE,aAAA;EAxEF;EA2EA;IACE,0BAAA;IACA,SAAA;EAzEF;EA4EA;IACE,eAAA;IACA,iBAAA;EA1EF;EA6EA;IACE,aAAA;EA3EF;EA8EA;IACE,gBAAA;EA5EF;EA8EE;IACE,aAAA;IACA,eAAA;EA5EJ;EAgFA;IACE,eAAA;IACA,gBAAA;EA9EF;EAiFA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EA/EF;AACF;AAkFA;EACE;IACE,aAAA;EAhFF;EAmFA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EAjFF;EAoFA;IACE,QAAA;IACA,eAAA;IACA,uBAAA;EAlFF;EAqFA;IACE,eAAA;IACA,iBAAA;EAnFF;EAuFA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;EArFF;EAuFE;IAEE,eAAA;EAtFJ;EAyFE;IAEE,eAAA;EAxFJ;EA4FA;IACE,aAAA;EA1FF;EA6FA;IACE,SAAA;EA3FF;EA8FA;IACE,eAAA;IACA,iBAAA;EA5FF;EA+FA;IACE,aAAA;IACA,gBAAA;EA7FF;EAgGA;IACE,gBAAA;EA9FF;EAgGE;IACE,YAAA;IACA,eAAA;EA9FJ;EAkGA;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EAhGF;EAoGE;IACE,eAAA;IACA,QAAA;EAlGJ;EAqGE;IACE,iBAAA;IACA,eAAA;EAnGJ;AACF;AAwGA;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,8CAAA;AAtGF;AAwGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAtGJ;AAwGI;EACE,eAAA;AAtGN;AAyGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sDAAA;AAvGN;AA2GE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzGJ;AA2GI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAzGN;AA2GM;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAzGR;AA4GM;EACE,eAAA;EACA,cAAA;EACA,sDAAA;EACA,gBAAA;AA1GR;;AAgHA;EACE;IACE,aAAA;IACA,cAAA;EA7GF;EAgHI;IACE,eAAA;EA9GN;EAoHM;IACE,eAAA;EAlHR;AACF;AAwHA;EACE;IACE,aAAA;IACA,cAAA;EAtHF;EAyHI;IACE,eAAA;EAvHN;EA6HM;IACE,eAAA;EA3HR;EA8HM;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA5HR;AACF","sourcesContent":[".dataVerificationContainer {\n  padding: 30px;\n  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);\n  border-radius: 12px;\n  margin-bottom: 30px;\n  max-width: 100%;\n  overflow-x: auto;\n  box-sizing: border-box;\n  min-height: 100vh;\n  position: relative;\n\n  // Content wrapper for better responsive design\n  .contentWrapper {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n\n  h2 {\n    text-align: center;\n    color: #2c3e50;\n    font-size: 2rem;\n    margin-bottom: 30px;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n\n// Upload Progress Indicator Styles\n.uploadProgressContainer {\n  background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);\n  border-radius: 15px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  color: white;\n  animation: slideDown 0.5s ease-out;\n\n  .progressHeader {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 20px;\n\n    .progressIcon {\n      font-size: 24px;\n      font-weight: bold;\n      background: rgba(255, 255, 255, 0.2);\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      animation: spin 0.6s linear infinite;\n    }\n\n    .progressTitle {\n      font-size: 18px;\n      font-weight: 600;\n      font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    }\n  }\n\n  .progressBarContainer {\n    position: relative;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 10px;\n    height: 20px;\n    margin-bottom: 15px;\n    overflow: hidden;\n\n    .progressBar {\n      height: 100%;\n      background: linear-gradient(90deg, #0467a0, #035a8a);\n      border-radius: 10px;\n      transition: width 0.3s ease;\n      position: relative;\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n        animation: shimmer 1.5s infinite;\n      }\n    }\n\n    .progressText {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      font-weight: bold;\n      font-size: 14px;\n      color: white;\n      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  .progressStatus {\n    font-size: 14px;\n    opacity: 0.9;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    text-align: center;\n  }\n}\n\n// Animations\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.searchContainer {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.searchBox {\n  flex: 1;\n}\n\n.searchInput {\n  width: 100%;\n  padding: 12px 20px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  transition: border-color 0.3s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #0467a0;\n    box-shadow: 0 0 0 3px rgba(4, 103, 160, 0.1);\n  }\n\n  &::placeholder {\n    color: #6c757d;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.itemsPerPageContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n\n  label {\n    font-weight: 600;\n    color: #495057;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.itemsPerPageSelect {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n}\n\n .filterToggleButton {\n   padding: 10px 20px;\n   border: 2px solid #0467a0;\n   border-radius: 8px;\n   background: linear-gradient(135deg, #0467a0, #ff0000);\n   color: white;\n   font-size: 14px;\n   font-weight: 600;\n   cursor: pointer;\n   transition: all 0.3s ease;\n   font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n   &:hover {\n     transform: translateY(-2px);\n     box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n   }\n }\n\n .actionButtons {\n   display: flex;\n   gap: 10px;\n   align-items: center;\n   flex-wrap: wrap;\n   justify-content: center;\n }\n\n .orderNote {\n   display: flex;\n   align-items: center;\n   gap: 8px;\n   padding: 8px 12px;\n   background: linear-gradient(135deg, #e6f3ff, #cce7ff);\n   border: 1px solid #0467a0;\n   border-radius: 8px;\n   margin: 10px 0;\n   font-size: 14px;\n   color: #0467a0;\n   font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n   box-shadow: 0 2px 8px rgba(4, 103, 160, 0.1);\n   transition: all 0.3s ease;\n\n   &:hover {\n     background: linear-gradient(135deg, #cce7ff, #b3d9ff);\n     transform: translateY(-1px);\n     box-shadow: 0 4px 12px rgba(4, 103, 160, 0.2);\n   }\n\n   .orderIcon {\n     font-size: 16px;\n     animation: pulse 2s infinite;\n   }\n\n   .orderText {\n     font-weight: 500;\n     \n     strong {\n       color: #0d47a1;\n     }\n   }\n }\n\n @keyframes pulse {\n   0% {\n     transform: scale(1);\n   }\n   50% {\n     transform: scale(1.1);\n   }\n   100% {\n     transform: scale(1);\n   }\n }\n\n // Navigation Arrows\n .navArrow {\n   display: inline-flex;\n   align-items: center;\n   justify-content: center;\n   width: 40px;\n   height: 40px;\n   border: 2px solid #667eea;\n   border-radius: 50%;\n   background: linear-gradient(135deg, #667eea, #764ba2);\n   color: white;\n   font-size: 18px;\n   font-weight: bold;\n   cursor: pointer;\n   transition: all 0.3s ease;\n   margin: 0 5px;\n   text-decoration: none;\n   font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n   &:hover {\n     transform: translateY(-2px) scale(1.1);\n     box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n     background: linear-gradient(135deg, #5a6fd8, #6a4190);\n   }\n\n   &:active {\n     transform: translateY(0) scale(0.95);\n   }\n\n   &.disabled {\n     opacity: 0.5;\n     cursor: not-allowed;\n     transform: none;\n     \n     &:hover {\n       transform: none;\n       box-shadow: none;\n     }\n   }\n\n   // Arrow icons using CSS\n   &.leftArrow::before {\n     content: '←';\n     font-size: 20px;\n     font-weight: bold;\n   }\n\n   &.rightArrow::before {\n     content: '→';\n     font-size: 20px;\n     font-weight: bold;\n   }\n\n   &.firstArrow::before {\n     content: '⟪';\n     font-size: 18px;\n     font-weight: bold;\n   }\n\n   &.lastArrow::before {\n     content: '⟫';\n     font-size: 18px;\n     font-weight: bold;\n   }\n }\n\n .actionButton {\n   padding: 10px 15px;\n   border: 2px solid #0467a0;\n   border-radius: 8px;\n   background: linear-gradient(135deg, #0467a0, #035a8a);\n   color: white;\n   font-size: 13px;\n   font-weight: 600;\n   cursor: pointer;\n   transition: all 0.3s ease;\n   font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n   white-space: nowrap;\n\n   &:hover {\n     transform: translateY(-2px);\n     box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n   }\n\n   &:nth-child(2) {\n     border-color: #ff0000;\n     background: linear-gradient(135deg, #ff0000, #cc0000);\n     \n     &:hover {\n       box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);\n     }\n   }\n\n   &:nth-child(3) {\n     border-color: #0467a0;\n     background: linear-gradient(135deg, #0467a0, #035a8a);\n     \n     &:hover {\n       box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n     }\n   }\n }\n\n.filterContainer {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n\n  h3 {\n    text-align: center;\n    color: #2c3e50;\n    font-size: 1.5rem;\n    margin-bottom: 25px;\n    font-weight: 600;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.filterSection {\n  margin-bottom: 30px;\n\n  h4 {\n    color: #495057;\n    font-size: 1.2rem;\n    margin-bottom: 15px;\n    font-weight: 600;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    border-bottom: 2px solid #e9ecef;\n    padding-bottom: 8px;\n  }\n}\n\n.filterGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.filterItem {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    font-weight: 600;\n    color: #495057;\n    font-size: 14px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.filterInput {\n  padding: 10px 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  transition: border-color 0.3s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  }\n\n  &::placeholder {\n    color: #6c757d;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.filterSelect {\n  padding: 10px 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  }\n}\n\n.filterInfo {\n  text-align: center;\n  padding: 15px;\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  border-radius: 8px;\n  margin-top: 20px;\n\n  span {\n    color: #495057;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.loadingContainer {\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n\n  p {\n    color: #6c757d;\n    font-size: 16px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.tableContainer {\n  background: white;\n  border-radius: 15px;\n  padding: 25px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n  \n  h3 {\n    text-align: center;\n    color: #2c3e50;\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n    font-weight: 600;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  }\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  min-width: 1400px; // Wider for more columns\n\n  th, td {\n    padding: 12px 8px;\n    text-align: center;\n    border: 1px solid #e9ecef;\n    font-size: 12px;\n    font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    vertical-align: middle;\n  }\n\n  th {\n    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n    color: white;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    \n    // Smaller font for complex headers\n    font-size: 11px;\n    \n    // Ensure proper alignment for rowSpan and colSpan\n    &:first-child {\n      text-align: center;\n    }\n  }\n\n  tbody tr {\n    transition: all 0.3s ease;\n\n    &:hover {\n      background-color: #f8f9fa;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    }\n  }\n  \n  // Responsive adjustments for detailed table\n  @media (max-width: 1200px) {\n    min-width: 1200px;\n    \n    th, td {\n      padding: 8px 4px;\n      font-size: 10px;\n    }\n  }\n}\n\n.statusContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.statusCheckbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #28a745;\n  \n  &:checked {\n    background-color: #28a745;\n    border-color: #28a745;\n  }\n}\n\n.statusLabel {\n  font-size: 16px;\n  font-weight: bold;\n  color: #28a745;\n  \n  &.approved {\n    color: #28a745;\n  }\n  \n  &.pending {\n    color: #dc3545;\n  }\n}\n\n.statusSelect {\n  padding: 6px 10px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  cursor: pointer;\n  min-width: 100px;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n}\n\n.commentInput {\n  padding: 6px 10px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  min-width: 120px;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n\n  &::placeholder {\n    color: #6c757d;\n    font-size: 11px;\n  }\n}\n\n.locationInput {\n  padding: 6px 10px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  background: white;\n  min-width: 100px;\n\n  &:focus {\n    outline: none;\n    border-color: #667eea;\n  }\n\n  &::placeholder {\n    color: #6c757d;\n    font-size: 11px;\n  }\n}\n\n.updateButton {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  background: linear-gradient(135deg, #0467a0, #035a8a);\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(4, 103, 160, 0.3);\n  }\n}\n\n.paginationContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  padding: 20px 0;\n  border-top: 2px solid #e9ecef;\n}\n\n.paginationInfo {\n  color: #6c757d;\n  font-size: 14px;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n}\n\n.paginationButtons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.paginationButton {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  background: white;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  min-width: 40px;\n\n  &:hover:not(:disabled) {\n    border-color: #0467a0;\n    color: #0467a0;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.active {\n    background: linear-gradient(135deg, #0467a0, #ff0000);\n    color: white;\n    border-color: #0467a0;\n  }\n}\n\n// Utility Classes\n.scrollableContent {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  \n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #0467a0;\n    border-radius: 4px;\n    \n    &:hover {\n      background: #035a8a;\n    }\n  }\n}\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.flexWrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .dataVerificationContainer {\n    padding: 20px;\n  }\n\n     .searchContainer {\n     flex-direction: column;\n     gap: 15px;\n   }\n\n   .itemsPerPageContainer {\n     width: 100%;\n     justify-content: center;\n   }\n\n   .actionButtons {\n     flex-wrap: wrap;\n     justify-content: center;\n     gap: 8px;\n   }\n\n   .actionButton {\n     font-size: 12px;\n     padding: 8px 12px;\n   }\n\n  .filterContainer {\n    padding: 20px;\n  }\n\n  .filterGrid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .filterInput, .filterSelect {\n    font-size: 13px;\n    padding: 8px 12px;\n  }\n\n  .tableContainer {\n    padding: 15px;\n  }\n\n  .table {\n    min-width: 800px;\n\n    th, td {\n      padding: 10px;\n      font-size: 12px;\n    }\n  }\n\n  .statusSelect, .commentInput, .locationInput {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n\n  .paginationContainer {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .dataVerificationContainer {\n    padding: 15px;\n  }\n\n  .searchContainer {\n    padding: 20px;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .actionButtons {\n    gap: 6px;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .actionButton {\n    font-size: 11px;\n    padding: 6px 10px;\n  }\n\n  // Navigation arrows for mobile\n  .navArrow {\n    width: 35px;\n    height: 35px;\n    font-size: 16px;\n    margin: 0 3px;\n\n    &.leftArrow::before,\n    &.rightArrow::before {\n      font-size: 18px;\n    }\n\n    &.firstArrow::before,\n    &.lastArrow::before {\n      font-size: 16px;\n    }\n  }\n\n  .filterContainer {\n    padding: 15px;\n  }\n\n  .filterGrid {\n    gap: 10px;\n  }\n\n  .filterInput, .filterSelect {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n\n  .tableContainer {\n    padding: 10px;\n    overflow-x: auto;\n  }\n\n  .table {\n    min-width: 700px;\n\n    th, td {\n      padding: 8px;\n      font-size: 11px;\n    }\n  }\n\n  .statusSelect, .commentInput, .locationInput {\n    font-size: 10px;\n    padding: 3px 6px;\n    min-width: 80px;\n  }\n\n  .paginationContainer {\n    .paginationButtons {\n      flex-wrap: wrap;\n      gap: 5px;\n    }\n\n    .paginationButton {\n      padding: 8px 12px;\n      font-size: 12px;\n    }\n  }\n}\n\n// Upload Instructions Styles\n.uploadInstructions {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border: 2px solid #2196f3;\n  border-radius: 12px;\n  padding: 20px;\n  margin: 20px 0;\n  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.1);\n\n  .instructionHeader {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n\n    .instructionIcon {\n      font-size: 20px;\n    }\n\n    .instructionTitle {\n      font-size: 16px;\n      font-weight: 700;\n      color: #1976d2;\n      font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n    }\n  }\n\n  .instructionSteps {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .instructionStep {\n      display: flex;\n      align-items: flex-start;\n      gap: 10px;\n      padding: 8px 0;\n\n      .stepNumber {\n        background: #2196f3;\n        color: white;\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        font-weight: 700;\n        flex-shrink: 0;\n        margin-top: 2px;\n      }\n\n      .stepText {\n        font-size: 14px;\n        color: #424242;\n        font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n        line-height: 1.4;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .uploadInstructions {\n    padding: 15px;\n    margin: 15px 0;\n\n    .instructionHeader {\n      .instructionTitle {\n        font-size: 14px;\n      }\n    }\n\n    .instructionSteps {\n      .instructionStep {\n        .stepText {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .uploadInstructions {\n    padding: 12px;\n    margin: 12px 0;\n\n    .instructionHeader {\n      .instructionTitle {\n        font-size: 13px;\n      }\n    }\n\n    .instructionSteps {\n      .instructionStep {\n        .stepText {\n          font-size: 12px;\n        }\n\n        .stepNumber {\n          width: 20px;\n          height: 20px;\n          font-size: 11px;\n        }\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataVerificationContainer": `verifydata_dataVerificationContainer__1iJNM`,
	"contentWrapper": `verifydata_contentWrapper__3O80X`,
	"uploadProgressContainer": `verifydata_uploadProgressContainer__5E4gW`,
	"slideDown": `verifydata_slideDown__2zbkr`,
	"progressHeader": `verifydata_progressHeader__908Wy`,
	"progressIcon": `verifydata_progressIcon__SYPE8`,
	"spin": `verifydata_spin__LwSTr`,
	"progressTitle": `verifydata_progressTitle__jmdAI`,
	"progressBarContainer": `verifydata_progressBarContainer__xQtv1`,
	"progressBar": `verifydata_progressBar__xnkEV`,
	"shimmer": `verifydata_shimmer__tt6iS`,
	"progressText": `verifydata_progressText__uO6US`,
	"progressStatus": `verifydata_progressStatus__88KQP`,
	"searchContainer": `verifydata_searchContainer__WPDAh`,
	"searchBox": `verifydata_searchBox__ek0hx`,
	"searchInput": `verifydata_searchInput__gke-w`,
	"itemsPerPageContainer": `verifydata_itemsPerPageContainer__CT6WU`,
	"itemsPerPageSelect": `verifydata_itemsPerPageSelect__Xq6qk`,
	"filterToggleButton": `verifydata_filterToggleButton__5rm2V`,
	"actionButtons": `verifydata_actionButtons__VgA7l`,
	"orderNote": `verifydata_orderNote__TsTNn`,
	"orderIcon": `verifydata_orderIcon__Xheh8`,
	"pulse": `verifydata_pulse__3mIv+`,
	"orderText": `verifydata_orderText__3v5mc`,
	"navArrow": `verifydata_navArrow__52jDC`,
	"disabled": `verifydata_disabled__QaMdP`,
	"leftArrow": `verifydata_leftArrow__rBcwC`,
	"rightArrow": `verifydata_rightArrow__gM2XI`,
	"firstArrow": `verifydata_firstArrow__jV+Bq`,
	"lastArrow": `verifydata_lastArrow__gu-Zx`,
	"actionButton": `verifydata_actionButton__QRowN`,
	"filterContainer": `verifydata_filterContainer__g7MuZ`,
	"filterSection": `verifydata_filterSection__c4nEP`,
	"filterGrid": `verifydata_filterGrid__P-1Og`,
	"filterItem": `verifydata_filterItem__Mpb1Y`,
	"filterInput": `verifydata_filterInput__79pGO`,
	"filterSelect": `verifydata_filterSelect__PqIFq`,
	"filterInfo": `verifydata_filterInfo__Rj-z6`,
	"loadingContainer": `verifydata_loadingContainer__pcCYB`,
	"tableContainer": `verifydata_tableContainer__75Pq2`,
	"table": `verifydata_table__Cne71`,
	"statusContainer": `verifydata_statusContainer__Dzy3I`,
	"statusCheckbox": `verifydata_statusCheckbox__A+22x`,
	"statusLabel": `verifydata_statusLabel__83Oe-`,
	"approved": `verifydata_approved__SZVSm`,
	"pending": `verifydata_pending__6JTOu`,
	"statusSelect": `verifydata_statusSelect__4f3rf`,
	"commentInput": `verifydata_commentInput__duTC5`,
	"locationInput": `verifydata_locationInput__rnYKW`,
	"updateButton": `verifydata_updateButton__GbJdW`,
	"paginationContainer": `verifydata_paginationContainer__cdH77`,
	"paginationInfo": `verifydata_paginationInfo__919AS`,
	"paginationButtons": `verifydata_paginationButtons__liaav`,
	"paginationButton": `verifydata_paginationButton__iecjO`,
	"active": `verifydata_active__QCLzJ`,
	"scrollableContent": `verifydata_scrollableContent__K2VCL`,
	"flexCenter": `verifydata_flexCenter__rqqh4`,
	"flexWrap": `verifydata_flexWrap__ols7f`,
	"uploadInstructions": `verifydata_uploadInstructions__N9WM8`,
	"instructionHeader": `verifydata_instructionHeader__j58vX`,
	"instructionIcon": `verifydata_instructionIcon__Ph51s`,
	"instructionTitle": `verifydata_instructionTitle__oVBrh`,
	"instructionSteps": `verifydata_instructionSteps__vyYXI`,
	"instructionStep": `verifydata_instructionStep__rflEx`,
	"stepNumber": `verifydata_stepNumber__qNjbo`,
	"stepText": `verifydata_stepText__Y-PhC`
};
export default ___CSS_LOADER_EXPORT___;
